import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PepperiSeparatorComponent } from './separator.component';

@NgModule({
    imports: [
        CommonModule,

    ],
    exports: [ PepperiSeparatorComponent ],
    declarations: [ PepperiSeparatorComponent ],
})
export class PepperiSeparatorModule {}
